import React, { FC } from "react";

import { defineMessages, useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import Info from "./Info";
import OptionInfo from "./OptionInfo";

const messages = defineMessages({
  alert: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip.alert",
    defaultMessage:
      "Pins will always be ones a user would normally have access to - only the legend may be affected.",
  },
  orgDataDescription: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip.ordData.description",
    defaultMessage: "The same buckets will be visible to all users.",
  },
  orgDataTitle: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip.ordData.title",
    defaultMessage: "Org Data",
  },
  title: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip",
    defaultMessage: "About visibility",
  },
  userDataDescription: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip.userData.description",
    defaultMessage:
      "Buckets could differ based on what the user has access to if using a non-manual classification method.",
  },
  userDataTitle: {
    id: "map.colorization.createEditSidebar.styleEditor.steps.accessLevel.tooltip.userData.title",
    defaultMessage: "User Data",
  },
});

export interface DataLevelInfoProps {}

const DataLevelInfo: FC<DataLevelInfoProps> = () => {
  const intl = useIntl();

  return (
    <Info title={intl.formatMessage(messages.title)}>
      <Alert message={intl.formatMessage(messages.alert)} showIcon type="info" />
      <OptionInfo
        description={intl.formatMessage(messages.orgDataDescription)}
        title={intl.formatMessage(messages.orgDataTitle)}
      />
      <OptionInfo
        description={intl.formatMessage(messages.userDataDescription)}
        title={intl.formatMessage(messages.userDataTitle)}
      />
    </Info>
  );
};

export default DataLevelInfo;
